import { z } from 'zod';
import { Category } from './category.js';
import { Goal } from './goal.js';
import { Account } from './account.js';
import { Depot } from './depot.js';
export const CreateYearRequest = z.object({
    year: z.number().int().min(1900).max(2200),
    from: z.number().int().min(1900).max(2200).optional(),
});
export const YearsResponse = z.array(z.number().int());
export const YearBundle = z.object({
    year: z.number().int(),
    categories: z.array(Category),
    goals: z.array(Goal),
    accounts: z.array(Account),
    depots: z.array(Depot),
});
